import styled from "@emotion/styled";
import { variant } from "styled-system";
import { Button as RebassButton } from "rebass";

const buttonSize = variant({
  prop: "size",
  key: "buttonSizes"
});

const Button = styled(RebassButton)`
  ${buttonSize}
  outline: 0;
  cursor: pointer;
  :disabled {
    pointer-events: none;
    ${"" /* opacity: 0.4 */}
  }
`;
// controls global opacity of all disabled buttons, unable to be overwritten via CCM
// commented out instead of removed for ease of finding this property in the future

Button.defaultProps = {
  my: 1,
  variant: "primary",
  minWidth: 120,
  sx: {
    borderRadius: 24
  }
};

export default Button;
